import React, { useEffect, useState } from 'react';
import { Container, Button, Switch, Title, Dialog, Input } from '@bsf/force-ui';
import { X, Check, Plus, ArrowRight, Package, CheckIcon } from 'lucide-react';
import { __ } from "@wordpress/i18n";
import toast, { Toaster } from 'react-hot-toast';
import '../../Styles.css';

const Create = () => {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    setIsActive(schemaSettingsData.analytics_status === 'yes');
  }, []);

  const handleSwitchChange = async () => {
    const newIsActive = !isActive;
    setIsActive(newIsActive);

    try {
      const response = await fetch(schemaSettingsData.ajax_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          action: 'save_analytics_data', // WordPress action for your AJAX handler.
          bsf_usage_optin: newIsActive ? 'yes' : 'no',
          nonce: schemaSettingsData.ajax_nonce // Nonce for security.
        })
      });

      const result = await response.json();

      if (result.success) {
        toast.success(__('Settings saved successfully!', 'wp-schema-pro'));
      } else {
        toast.error(__('Failed to save settings!', 'wp-schema-pro'));
      }
    } catch (error) {
      toast.error(__('Failed to save settings!', 'wp-schema-pro'));
    }

    // setIsLoading(false);
  };

  return (
    <div className="bg-background-primary border-[0.5px] border-subtle rounded-xl shadow-sm mb-6 p-10" style={{ maxWidth: '45%' }}>
      <div className="flex items-start">
        {/* Left Content */}
        <div className="flex flex-col items-start" style={{ paddingRight: '35px' }}>
          <h1 className="text-text-primary m-0 mb-2 text-2xl" style={{ lineHeight: '1.3em' }}>
            {__("You're all set!🚀", "wp-schema-pro")}
          </h1>
          <span className="font-medium text-text-tertiary m-0 mb-4 schema-88-width" style={{ lineHeight: '1.9em', paddingTop: '8px', fontSize: '0.9rem' }}>
            {__(
              "You've successfully added schema to your website! You're on your way to get rich snippets for your pages.",
              "wp-schema-pro"
            )}
          </span>
          <span className="font-medium m-0 pt-1" style={{ fontSize: '1.2rem' }}>
            {__("Wondering what's next:", "wp-schema-pro")}
          </span>


          <ul className="list-none font-normal " style={{ fontSize: '0.9rem', lineHeight: '1.6em', paddingBottom: '0.5rem', color: '#111827' }}>
            <li className="none  text-text-tertiary " style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '0.5rem' }}>
              <CheckIcon color="#E62A5E" size={18} />
              {__('Create schema markups.', 'wp-schema-pro')}
            </li>
            <li className="none  text-text-tertiary " style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '0.5rem' }}>
              <CheckIcon color="#E62A5E" size={18} />
              {__('Set schema markups for your individual pages.', 'wp-schema-pro')}
            </li>
            <li className="none  text-text-tertiary " style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '0.5rem' }}>
              <CheckIcon color="#E62A5E" size={18} />
              {__('Explore other advanced features.', 'wp-schema-pro')}
            </li>
          </ul>

          <Button
            icon={<ArrowRight />}
            iconPosition="right"
            variant="primary"
            className="bg-[#E62A5E] schema-remove-ring"
            style={{
              backgroundColor: "#E62A5E",
              transition: "background-color 0.3s ease",
              padding: '12px 20px',
              outlineColor: "#E62A5E",
            }}
            onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor =
              "#E62A5E")
            }
            onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor =
              "#E62A5E")
            }
            onClick={() => {
              window.location.href = schemaSettingsData.wpsp_schema_type_url;
            }}
          >
            {__("Create First Schema", "wp-schema-pro")}
          </Button>

        </div>

        {/* Right Content - Image */}
        <div className="w-1/2" style={{ textAlign: 'end' }}>
          <img
            alt="Build"
            className="w-full object-contain"
            style={{ height: 'auto', width: 'auto' }}
            src={`${schemaSettingsData.create_banner}`}
            loading="lazy"
          />
        </div>
      </div>

      {/* <hr className="w-full border-b-0 border-x-0 border-t border-solid border-t-border-subtle" style={{ marginTop: '34px', marginBottom: '34px', borderColor: '#E5E7EB' }} /> */}

      {/* <div className="bg-badge-background-gray border-[0.5px] border-subtle p-6" style={{ borderRadius: '5px'}}>
        <div className='flex flex-row items-center justify-start px-1 gap-3'>
          <Switch
            onChange={handleSwitchChange}
            size='xs'
            value={isActive}
            className="schema-remove-ring"
          />
          <span className="font-bold text-text-primary m-0" style={{ fontSize: '1rem', paddingBottom: '15px', paddingTop: '15px' }}>
            {__("Help make Schema Pro Better", "wp-schema-pro")}
          </span>
        </div>
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          containerStyle={{
            top: 20,
            right: 20,
            marginTop: '40px',
          }}
          toastOptions={{
            duration: 1000,
            style: {
              background: 'white',
            },
            success: {
              duration: 2000,
              style: {
                color: '',
              },
              iconTheme: {
                primary: '#E62A5E',
                secondary: '#fff',
              },
            },
          }}
        />
        <span className='flex flex-row items-center justify-start mt-4 gap-3' style={{ lineHeight: '1.5em', fontSize: '0.95em' }}>{__("Help us improve by sharing anonymous data about your website setup. This includes non-sensitive info about plugins, themes, and settings, so we can create a better product for you. Your privacy is always our top priority. Learn more in our privacy policy.", "wp-schema-pro")}</span>
      </div> */}
    </div>
  )
}

export default Create
